import React, { useCallback, useMemo, useRef } from "react";
import { Stack, Chip, Button, Text } from "@bookingcom/bui-react";
import { useWeekendTopFiltersController } from "./useWeekendTopFilters.controller";
import useFlightsWebWeekendTopFilter from "../../../../../utils/experiments/funnel/flights_web_weekend_top_filter";

export function WeekendTopFiltersMobile() {
  const {
    title,
    onReset,
    restText,
    directFlights,
    eveningReturnFlights,
    budgetFriendlyFlights,
    morningDepartureflights,
    cabinBaggageIncludedFlights
  } = useWeekendTopFiltersController();

  const list = useMemo(
    () => [
      directFlights,
      eveningReturnFlights,
      budgetFriendlyFlights,
      morningDepartureflights,
      cabinBaggageIncludedFlights
    ],
    [directFlights, morningDepartureflights, budgetFriendlyFlights, eveningReturnFlights, cabinBaggageIncludedFlights]
  );
  const canRender = useMemo(() => list.filter(Boolean).length, [list]);
  const showReset = useMemo(() => list.find((l) => l?.checked), [list]);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const { isVariant, goals } = useFlightsWebWeekendTopFilter(); // flights_web_weekend_top_filter
  const onClick = useCallback(() => {
    goals.clear();
    onReset();
    setTimeout(() => {
      wrapperRef?.current?.getElementsByTagName("label")[0]?.focus();
    }, 1);
  }, [onReset, goals, wrapperRef]);

  if (!canRender) return null;
  if (!isVariant()) return null;

  return (
    <Stack
      direction="row"
      gap={1}
      justifyContent="start"
      alignItems="start"
      grow
      wrap="wrap"
      attributes={{ ref: wrapperRef }}
    >
      {title ? (
        <Stack.Item mixin={{ paddingBlockEnd: 1 }} grow>
          <Text tagName="h3" variant="emphasized_1">
            {title}
          </Text>
        </Stack.Item>
      ) : undefined}
      {directFlights ? <Chip {...directFlights} /> : undefined}
      {morningDepartureflights ? (
        <Chip
          {...morningDepartureflights}
          onChange={(a: any) => {
            goals.morning();
            morningDepartureflights.onChange(a);
          }}
        />
      ) : undefined}
      {eveningReturnFlights ? (
        <Chip
          {...eveningReturnFlights}
          onChange={(a: any) => {
            goals.evening();
            eveningReturnFlights.onChange(a);
          }}
        />
      ) : undefined}
      {cabinBaggageIncludedFlights ? (
        <Chip
          {...cabinBaggageIncludedFlights}
          onChange={(a: any) => {
            goals.cabin();
            cabinBaggageIncludedFlights.onChange(a);
          }}
        />
      ) : undefined}
      {budgetFriendlyFlights ? (
        <Chip
          {...budgetFriendlyFlights}
          onChange={(a: any) => {
            goals.budget();
            budgetFriendlyFlights.onChange(a);
          }}
        />
      ) : undefined}
      {showReset ? <Button variant="tertiary" onClick={onClick} text={restText} /> : undefined}
    </Stack>
  );
}
